import { AssociateLearnContentComponent } from "./associate-learn-content/associate-learn-content.component";
import { ContentProductAssociationComponent } from "./content-product-association/content-product-association.component";
import { ProductSearchPickerComponent } from "./product-search-picker/product-search-picker.component";
import { AdminFenderProductsComponent } from "./fender-products/fender-products.component";
import { AdminFenderProductDetailComponent } from "./fender-product-detail/fender-product-detail.component";
import { GenerateKeysComponent } from "./generate-keys/generate-keys.component";
import { AdminHardwareSerialsComponent } from "./hardware-serials/hardware-serials.component";
import { KillKeysComponent } from "./kill-keys/kill-keys.component";
import { AdminLicenseKeyImportComponent } from "./license-key-import/license-key-import.component";
import { ProductCategoriesComponent } from "./product-categories/product-categories.component";
import { AdminProductListComponent } from "./product-list/product-list.component";
import { AdminSubscriptionProductGroupsComponent } from "./subscription-product-groups/subscription-product-groups.component";
import { AdminSubscriptionProductListComponent } from "./subscription-product-list/subscription-product-list.component";
import { AdminPendingGiveawaysComponent } from "./pending-giveaways/pending-giveaways.component";
import { GiveawayManagementComponent } from "./giveaway-management/giveaway-management.component";
import { ContentPackagesManagerComponent } from "./content-packages-manager/content-packages-manager.component";

import { AiAssistantConfigComponent } from "./ai-assistant-config/ai-assistant-config.component";
import { AiAssistantUsageComponent } from "./ai-assistant-usage/ai-assistant-usage.component";
import { AdminEventFormComponent } from "./events-manager/admin-event-form.component";
import { EventsManagerComponent } from "./events-manager/events-manager.component";
import { MissingSerialItemComponent } from "./missing-serial-item/missing-serial-item.component";
import { LocalizedDescriptionsEditorComponent } from "./localized-descriptions-editor/localized-descriptions-editor.component";
import { FirmwareInstructionsManagerComponent } from "./firmware-instructions-manager/firmware-instructions-manager.component";
import { FirmwareInstructionFormComponent } from "./firmware-instructions-manager/firmware-instruction-form.component";
export const ADMINPORTAL_COMPONENTS = [
  LocalizedDescriptionsEditorComponent,
  GenerateKeysComponent,
  AdminProductListComponent,
  AdminFenderProductsComponent,
  AdminFenderProductDetailComponent,
  AssociateLearnContentComponent,
  ContentProductAssociationComponent,
  ProductSearchPickerComponent,
  ProductCategoriesComponent,
  AdminHardwareSerialsComponent,
  AdminLicenseKeyImportComponent,
  AdminSubscriptionProductGroupsComponent,
  AdminSubscriptionProductListComponent,
  KillKeysComponent,
  AdminPendingGiveawaysComponent,
  GiveawayManagementComponent,
  AiAssistantConfigComponent,
  AiAssistantUsageComponent,
  ContentPackagesManagerComponent,
  MissingSerialItemComponent,
  EventsManagerComponent,
  AdminEventFormComponent,
  FirmwareInstructionsManagerComponent,
  FirmwareInstructionFormComponent,
];

export * from "./generate-keys/generate-keys.component";
export * from "./product-list/product-list.component";
export * from "./fender-products/fender-products.component";
export * from "./fender-product-detail/fender-product-detail.component";
export * from "./associate-learn-content/associate-learn-content.component";
export * from "./content-product-association/content-product-association.component";
export * from "./product-search-picker/product-search-picker.component";
export * from "./hardware-serials/hardware-serials.component";
export * from "./product-categories/product-categories.component";
export * from "./license-key-import/license-key-import.component";
export * from "./subscription-product-groups/subscription-product-groups.component";
export * from "./subscription-product-list/subscription-product-list.component";
export * from "./kill-keys/kill-keys.component";
export * from "./pending-giveaways/pending-giveaways.component";
export * from "./giveaway-management/giveaway-management.component";
export * from "./ai-assistant-config/ai-assistant-config.component";
export * from "./ai-assistant-usage/ai-assistant-usage.component";
export * from "./content-packages-manager/content-packages-manager.component";
export * from "./missing-serial-item/missing-serial-item.component";
export * from "./events-manager/events-manager.component";
export * from "./events-manager/admin-event-form.component";
export * from "./localized-descriptions-editor/localized-descriptions-editor.component";
export * from "./firmware-instructions-manager/firmware-instructions-manager.component";
export * from "./firmware-instructions-manager/firmware-instruction-form.component";
